import dayjs from 'dayjs'

/**
 * Compares the query date with the current date and checks if the query hours has expired
 * @param queryDate date you want to query
 * @param queryHours optional hours expired you want to query - 24 if unset
 * @returns boolean
 */
export const hasHoursExpired = (queryDate: Date, queryHours = 24) => {
  const queryDateConverted = dayjs(queryDate)
  const currentDate = dayjs()
  const hoursDifference = currentDate.diff(queryDateConverted, 'hours')
  const isHoursExpired = hoursDifference >= queryHours
  return isHoursExpired
}
